import { zodResolver } from '@hookform/resolvers/zod';
/**
 * @deprecated Pass `zodResolver(schema)` directly to `useForm` instead as it's memoized internally.
 * @example
 * const form = useForm({
 *  resolver: zodResolver(schema),
 * });
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const useResolver = (schema) => zodResolver(schema);
